<img
  [src]="image.src"
  [style.object-fit]="objectFit"
  [style.border-radius]="borderRadius+'px'"
  (load)="imageHasLoaded()"
  draggable="false">
